// ICE/TURN server configuration, always fetched from the backend (never hardcoded).
// Replaces the old Redux LoaderReducer.turnDetails that peer.service read at
// connection-creation time.
import { httpRequest } from './http'

let iceConfig: any = null

export const setIceConfig = (config: any) => {
  iceConfig = config
}

export const getIceConfig = () => iceConfig

// ABSOLUTE EXPIRY (EPOCH MS) OF THE CURRENT ICE CONFIG, WHEN THE BACKEND SENDS ONE
// (ROADMAP #11/#13: A COTURN-BACKED servertype REPLIES WITH expiresAt/ttlSeconds; TODAY'S
// PRODUCTION TWILIO PATH DOES NOT). null MEANS "NO REFRESH SHOULD BE SCHEDULED" - EITHER
// NOTHING WAS FETCHED YET OR THE BACKEND DID NOT SEND AN EXPIRY.
let iceConfigExpiresAt: number | null = null

export const getIceConfigExpiresAt = () => iceConfigExpiresAt

// response.expiresAt (EPOCH MS OR ISO STRING) IS PREFERRED; response.ttlSeconds (RELATIVE
// TO "NOW") IS THE FALLBACK. NEITHER PRESENT -> null.
const parseIceConfigExpiresAt = (response: any): number | null => {
  if (response?.expiresAt) {
    const asEpochMs = new Date(response.expiresAt).getTime()
    return Number.isFinite(asEpochMs) ? asEpochMs : null
  }
  if (typeof response?.ttlSeconds === 'number' && response.ttlSeconds > 0) {
    return Date.now() + response.ttlSeconds * 1000
  }
  return null
}

// GET /serverDetails/iceserver -> { status, webIceConfig: { iceServers: [...] }, expiresAt?, ttlSeconds? }
export const fetchIceConfig = async (): Promise<any> => {
  try {
    const response = await httpRequest('serverDetails/iceserver', 'GET')
    if (response?.status === 'success' && response?.webIceConfig) {
      setIceConfig(response.webIceConfig)
      iceConfigExpiresAt = parseIceConfigExpiresAt(response)
      return response.webIceConfig
    }
  } catch (error) {
    console.error('Error fetching ICE server details:', error)
  }
  return null
}
